// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:767px){.error-contact[data-v-6a3f0a55]{text-align:center}}.error-contact__link[data-v-6a3f0a55]{color:#1335f5;cursor:pointer;font-size:inherit;line-height:inherit}", ""]);
// Exports
module.exports = exports;
